import styled from 'styled-components'
import { lightTheme } from '@/constants'
import SectionWrapper from '@/components/SectionWrapper'

export const ContentItemsContainer = styled(SectionWrapper)`
  background: ${({ theme }) => theme.sectionTheme?.background || lightTheme.background};
`
